exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label {\n\tfont-size: 10pt;\n\tfont-weight: normal;\n\tcolor: #444;\n}\n\n.selectedRow,  .selectedRow:hover {\n\tbackground-color: #a1d6a2;\n}\n\n.srm-sort-link {\n\tcolor: white;\n\ttext-decoration: none;\n\tfont-weight: bold;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/equipment-defs/equipment-defs.component.css
// module id = 334
// module chunks = 0